import { getSelectedCollection } from "../home_ui/selectors";

export const getCircles=(state, featured)=>{     
    const circles =  featured? state.circles_in_collection.featured : state.circles_in_collection.all;
    const circles_from_collection = circles[getSelectedCollection(state)];
    return circles_from_collection ? circles_from_collection : [];
}

//TODO: refactor this function 

const isFetchingCircles = (state, collection, featured) => {
    let loading_circles = featured ? state.circles_in_collection.loading_featured : state.circles_in_collection.loading_all;
  
    if (loading_circles[collection] === true) {
      return true;
    } else {
      return false;
    }
};

export const shouldFetchCirclesInCollection = (state, collection, offset, featured) => {   
    if (isFetchingCircles(state, collection, featured)) {
      return false;
    }
    let next_offset = featured ? state.circles_in_collection.next_featured_offset : state.circles_in_collection.next_all_offset;
  
    if (offset < next_offset[collection]) {
      return false;
    }
    return true;
};

export const loadingInitialCirclesList=(state, featured)=>{
    const circles = featured?state.circles_in_collection.featured:state.circles_in_collection.all;
    return ( 
        isFetchingCircles(state, featured) && (Object.keys(circles).length === 0)
    )
}

export const hasMoreCirclesInSelectedCollection = (state, featured) => {
  return featured
    ? state.circles_in_collection.has_more_featured[getSelectedCollection(state)]
    : state.circles_in_collection.has_more_all[getSelectedCollection(state)];
};

export const getNextOffsetInCirclesCollection = (state, featured) => {
  return featured
    ? state.circles_in_collection.next_featured_offset[getSelectedCollection(state)]
    : state.circles_in_collection.next_all_offset[getSelectedCollection(state)];
};
 
//TODO: refactor this function 
export const loadingMoreCirclesForSelectedCollection = (state, featured) => {
  return (
    getCircles(state, featured).length &&
    isFetchingCircles(state, getSelectedCollection(state), featured)
  );
};